{
    "coordinates": [
        5.500846925158513,
        -73.49568160097971
    ],
    "tooltip": "Paja",
    "title": "Paja Formation",
    "country": "Colombia",
    "period": "Cretaceous",
    "alt": "TODO"
}
